import React from "react";
import { useWorkflow } from "../../workflow/WorkflowContext";
import { SignoffPanel } from "../../components/SignoffPanel";
import { NoActiveCalcNotice } from "../../components/NoActiveCalcNotice";
import { authClient } from "../../lib/authApi";

/** Step 5 — Sign-off. v0.6 nav refactor: dedicated route component. */
export default function Step5Signoff() {
  const { calc, state, setCalc, setActiveStep, commitCalc } = useWorkflow();
  // A2-479 — the re-run that added the acknowledged EU sales is the calc to
  // sign: load its review first, then switch calc + review in one step (a
  // new calc must never be shown against the old calc's review).
  const switchToRecalculated = async (result) => {
    let review = null;
    try {
      const { data } = await authClient.get(`/runs/calc/${result.id}/review-grouped`,
        { params: { page: 1, page_size: 50 } });
      review = data;
    } catch { review = null; }
    commitCalc(result, review, result.client_id);
  };
  if (!calc) return <NoActiveCalcNotice onGoToUpload={() => setActiveStep(1)} />;
  return (
    <section data-testid="step-5-signoff" className="space-y-3">
      {/* A2-479 — onRecalculated: the re-run that added the acknowledged EU sales is the one to sign */}
      <SignoffPanel calc={calc}
        onRecalculated={switchToRecalculated}
        onSigned={(record) => {
          // Merge the signoff record onto the calc so the workflow
          // derivation fires (signedOff → Step 5 complete, Step 6
          // unlocked).
          //
          // v0.6.8 fix — the comment above used to end "Operator then
          // advances to Freeze via the stepper," but that's a dead end:
          // the Stepper only unlocks a tab once it's marked complete OR
          // it IS the current URL-pinned step (Stepper.jsx's
          // `isLocked = !isComplete && !isActive`). Step 6 can never be
          // "complete" until it's already frozen — circular — and
          // staying on the /workflow/signoff route keeps `activeStep`
          // pinned at 5. So once signed off with nothing left blocking,
          // there was literally no clickable path to Step 6 at all
          // (operator-reported 2026-09-04: "no button after sign off").
          // Sign-off is only enabled once step 4 is already complete
          // (see signoffDisabled below), so a successful sign-off always
          // means step 5 is now complete too — safe to advance directly.
          if (record) {
            setCalc({
              ...calc,
              signoff_id: record.id,
              signed_off_at: record.signed_at_utc,
              signed_off_by: record.operator_name,
            });
            setActiveStep(6);
          }
        }}
        signoffDisabled={!state.steps[4].complete}
        signoffTooltip={!state.steps[4].complete ? state.steps[5].blockers[0] : ""}
        step6Blockers={state.steps[6].blockers}
        onAdvance={() => setActiveStep(6)}
      />
    </section>
  );
}
